module.exports = __webpack_public_path__ + "media/images/antara1-62eb70abdcbcda696f190889e2b3e1fb.png";